export default "__VITE_ASSET__DleSnZIE__"